export default {
  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE',
  SWITCH_BUTTON: 'SWITCH_BUTTON',
}


// WEBPACK FOOTER //
// ./src/store/intl/types.js